import { z } from 'zod';

export const AssetMetadataSchema = z
    .object({
        name: z.string(),
        type: z.string(),
        data: z.string(),
    })
    .describe('AssetMetadataSchema');

export const ImageSchema = z
    .object({
        fullpath: z.string(),
        // no problem if we don't receive metada and not all queries ask for it
        metadata: z.array(AssetMetadataSchema).nullable().optional(),
    })
    .describe('ImageSchema');

export const HotspotImageSchema = z
    .object({
        image: ImageSchema,
        // We don't use `hotspots`, `crop` or `marker` fields in the current implementation,
    })
    .describe('HotspotImageSchema');

export const ImageWithThumbSchema = ImageSchema.extend({
    thumbnailUrl: z.string(),
}).describe('ImageWithThumbSchema');

export const HotspotImageWithThumbSchema = HotspotImageSchema.extend({
    image: ImageWithThumbSchema,
}).describe('HotspotImageWithThumbSchema');
